module.exports = __webpack_public_path__ + "img/Abstract-selection.6843dfad.svg";